import { createSlice, PayloadAction } from "@reduxjs/toolkit"

interface ContactState {
	isSubmitting: boolean
	submitSuccess: boolean
	submitError: string | null
}

const initialState: ContactState = {
	isSubmitting: false,
	submitSuccess: false,
	submitError: null
}

const contactSlice = createSlice({
	name: "contact",
	initialState,
	reducers: {
		submitContactStart: state => {
			state.isSubmitting = true
			state.submitSuccess = false
			state.submitError = null
		},
		submitContactSuccess: state => {
			state.isSubmitting = false
			state.submitSuccess = true
			state.submitError = null
		},
		submitContactFailure: (state, action: PayloadAction<string>) => {
			state.isSubmitting = false
			state.submitSuccess = false
			state.submitError = action.payload
		},
		resetContactForm: state => {
			state.isSubmitting = false
			state.submitSuccess = false
			state.submitError = null
		}
	}
})

export const { submitContactStart, submitContactSuccess, submitContactFailure, resetContactForm } =
	contactSlice.actions

export default contactSlice.reducer
